import { Component, OnInit, Input } from '@angular/core';
 
import { StandService } from 'src/app/service/stand.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Stand } from 'src/app/entity/Stand';
import { MatTableDataSource } from '@angular/material/table';
 
 
 
@Component({
  selector: 'list-stand-projet',
  templateUrl: './stand-projet.component.html',
  styleUrls: ['./stand-projet.component.scss']
})
export class StandProjetComponent implements OnInit {

  constructor(private standService:StandService,private exhibitorService:ExhibitorService) { }

@Input() projectId: number;
@Input() clientId: number;
@Input() showListStands: boolean;

   shwoAssigned=false;
   dataSource=new MatTableDataSource();
   columnsToShow= ['num','standType','superficie','clients','action']

  ngOnInit() {
    this.findStands();
  }
  findStands() {
    this.standService.findStandsByProject(this.projectId,this.shwoAssigned).subscribe(data => {
      this.dataSource.data = data;
 
    })

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


 async select(stand: Stand) {
 
 await  this.exhibitorService.updateStands(this.clientId,stand.idStand,true);
 this.findStands()
 this.exhibitorService.subscribeStandClient(this.clientId);
 this.showListStands=false
  }
  onShowAll(){
    if(this.shwoAssigned)
    this.columnsToShow= ['num','standType','superficie','clients','action']
else
    this.columnsToShow= ['num','standType','superficie' ,'action']


    this.findStands()
  }
}